import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { RouterOutlet } from '@angular/router/src/directives/router_outlet';
import { trigger, state, style, transition, animate, group, query, stagger, keyframes } from '@angular/animations';

export const SlideAnimation = trigger('SlideAnimation', [
  transition('kvap0300 => kvap0301', [
    // 右スワイプ用
    query(':enter, :leave', style({ position: 'fixed', width: '100%' })
      , { optional: true }),
    group([
      query(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
      ], { optional: true }),
      query(':leave', [
        style({ transform: 'translateX(0%)' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(-100%)' }))
      ], { optional: true }),
    ])
  ]),
  transition('kvap0301 => kvap0300', [
    // 左スワイプ用
    query(':enter, :leave', style({ position: 'fixed', width: '100%' })
      , { optional: true }),
    group([
      query(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(0%)' }))
      ], { optional: true }),
      query(':leave', [
        style({ transform: 'translateX(0%)' }),
        animate('0.5s ease-in-out', style({ transform: 'translateX(100%)' }))
      ], { optional: true }),
    ])
  ]),
]);


@Component({
  templateUrl: './kvap0302.component.html',
  animations: [SlideAnimation],
})
export class Kvap0302Component implements OnInit {

  constructor(public router: Router) { }

  ngOnInit() {
  }

  getState(outlet: RouterOutlet) {
    return outlet.activatedRouteData.state;
  }
}



// WEBPACK FOOTER //
// ./src/app/component/kvap0302/kvap0302.component.ts